module.exports = __webpack_public_path__ + "img/icon_yinhangka@2x.8e235f79.png";